import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import CookieBanner from "../../../components/cookies";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "data-analytics-ethics-triage",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#data-analytics-ethics-triage",
        "aria-label": "data analytics ethics triage permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Data analytics ethics triage`}</h1>
    <p>{`This site is home to a `}<a parentName="p" {...{
        "href": "/csc-sandbox/ethics-triage"
      }}>{`data analytics ethics triage tool`}</a>{`, intended to be used as part of `}{`[CDEI/DfE]`}{`'s `}<a parentName="p" {...{
        "href": "https://www.gov.uk/tbc"
      }}>{`ethics guidance for data analytics in children's social care`}</a>{`.`}</p>
    <p>{`The triage is an online self-assessment tool which can help you understand the different risk factors associated with your use case and proposed solution. The triage poses a series of questions about these factors, and recommends that you pay particular attention to specific 'explainer' themes in the guidance in order to mitigate risk.`}</p>
    <h2 {...{
      "id": "what-you-need-to-know",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#what-you-need-to-know",
        "aria-label": "what you need to know permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`What you need to know`}</h2>
    <p>{`The ethics triage should be used after completing the `}<em parentName="p">{`Exploratory`}</em>{`, `}<em parentName="p">{`Problem Identification`}</em>{`, and `}<em parentName="p">{`Choosing a Data Analytics Solution`}</em>{` stages of the guidance. Completing these stages fully should ensure you have all the information required to complete the ethics triage.`}</p>
    <p>{`Concretely, you should understand the following:`}</p>
    <ul>
      <li parentName="ul">{`What problem your proposed data analytics solution is intending to solve`}</li>
      <li parentName="ul">{`What the intended value of your use case is, who is likely to benefit, and how`}</li>
      <li parentName="ul">{`What type of data analytics (descriptive, diagnostic or predictive) you will use`}</li>
      <li parentName="ul">{`Details of where similar tools have been deployed in the past`}</li>
      <li parentName="ul">{`Who will be directly using the tool and who will be directly affected by it`}</li>
      <li parentName="ul">{`Your organisational data maturity`}</li>
      <li parentName="ul">{`What datasets may be needed to develop the tool`}</li>
    </ul>
    <p>{`You can then proceed to the `}<a parentName="p" {...{
        "href": "/csc-sandbox/ethics-triage"
      }}>{`ethics triage`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      